<template lang="pug">
.setup
  .card-item
    div(v-if="!complete")
      //- h5 Tell us about your company
      form(@submit.prevent='contact()')
        //.form-group
          label Name
          input(type='text', v-model='companyInfo.name', required)
        .form-group(v-if='preferredContact === "email"')
          //- label Email
          input(type='email', placeholder='Email', v-model='email', required)
        //- .form-group
        //-   label Tell us about you and your business?
        //-   textarea(v-model='companyInfo.description', required)
        //.form-group
          label How would you like to be contacted?
          b-form-select(v-model="preferredContact", :options="options", required)
        //.form-group(v-if='preferredContact === "phone"')
          label Phone
          input(type='phone', v-model='phone', required)
        button.btn.btn-primary(v-if='!isLoading', type='submit') Contact
        button.btn.btn-primary(v-else, disabled) Loading...
    div(v-else)
      h5.text-center Great! We will contact you soon.
</template>

<style lang="scss">
  .card-item {
    width: 100%;
  }

  input, textarea {
    padding: 6px 12px;
    width: 100%;
    font-size: 16px;
    line-height: 1.5;
    color: #555;
    background-color: #fff;
    background-image: none;
    border: 1px solid #e7e9ec;
    border-radius: 3px;
    -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
    box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
    -webkit-transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
    -o-transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
    transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
  }
</style>

<script>
import { sendContact } from '../lib/api'

export default {
  data () {
    return {
      email: '',
      phone: '',
      companyInfo: {
      },
      preferredContact: 'email',
      options: [
        { value: 'email', text: 'Email' },
        { value: 'phone', text: 'Phone' }
      ],
      isLoading: false,
      complete: false
    }
  },
  methods: {
    async contact () {
      this.companyInfo.email = this.email
      this.companyInfo.phone = this.phone
      this.companyInfo.date = new Date()
      this.isLoading = true
      await sendContact(this.companyInfo)
      this.isLoading = false
      this.complete = true
      // this.step = 3
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/MainContact.vue